module.exports = __webpack_public_path__ + "ve.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/ve.svg
// module id = 878
// module chunks = 0